import { newsApi } from './api';
import {GET_SELECT_DRIVER_ENDPOINT} from "./apiConstant";

export const BrokerService = newsApi.injectEndpoints({
    endpoints: (build) => ({
        getSelectBrokers: build.query({
            query: () => ({
                url: `select/brokers`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: [''],
        }),
        getBroker: build.query({
            query: ({ pagination }) => ({
                url: `broker-companies${pagination && pagination}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        addBroker: build.mutation({
            query: (form) => ({
                url: `broker-companies/store`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        editBroker: build.mutation({
            query: ({ id, newForm }) => ({
                url: `broker-companies/update/${id}`,
                method: 'PUT',
                body: newForm,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        removeBroker: build.mutation({
            query: (id) => ({
                url: `broker-companies/delete/${id}`,
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetSelectBrokersQuery,
    useGetBrokerQuery,
    useAddBrokerMutation,
    useEditBrokerMutation,
    useRemoveBrokerMutation,
} = BrokerService